// Utils

// Compoennts
// import Link from 'next/link'

// Styles
import {
  ButtonContainer,
  // AContainer
} from './button.styles'

// Types
import {
  //  IButtonLinkProps,
  IButtonProps,
} from './button.types'

export const Button = (props: IButtonProps) => {
  return <ButtonContainer {...props}>{props.children}</ButtonContainer>
}

// export const ButtonLink = (props: IButtonLinkProps) => {
//   return (
//     <AContainer {...props}>
//       <Link href={props.href || '#'}>{props.children}</Link>
//     </AContainer>
//   )
// }
